export const CERTIFICATE_PREVIEW_LEARNER = {
    fullName: '[ User Name ]',
    dateOfBirth: '[ Date of Birth ]',
    nationality: '[ Nationality ]',
    completionMethod: 'Standard - Final quiz',
} as const;

export const CERTIFICATE_PREVIEW_NO_TITLE = '[ Pathway title ]';
export const CERTIFICATE_PREVIEW_NO_VERSION = '[ Version ]';

// The pathway form hands its current values to the preview tab through localStorage (read once, then deleted).
export const CERTIFICATE_PREVIEW_STORAGE_KEY_PREFIX = 'certificate-preview:';
